import React from 'react';

const Biotechnology = () => {
  return (
    <div>
      Biotechnology
      Biotechnology
    </div>
  );
}

export default Biotechnology;
